import { render, staticRenderFns } from "./RequestCreateUpdate.vue?vue&type=template&id=62f0ad19"
import script from "./RequestCreateUpdate.vue?vue&type=script&lang=ts"
export * from "./RequestCreateUpdate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports